// extracted by mini-css-extract-plugin
export var heroImage = "_kn-1";
export var modal = "_kn-0";